import Card from "Components/Common/Card/Card";
import CardContent from "Components/Common/Card/CardContent/CardContent";
import CardImage from "Components/Common/Card/CardImage/CardImage";
import RouterLink from "Components/RouterLink/RouterLink";
import { RouterLinkType } from "Enums/RouterLinkType";
import { TaskTemplate } from "Models/Tasks/TaskTemplate";
import * as React from "react";
import TaskRecurrencyBlock from "./TaskRecurrencyBlock/TaskRecurrencyBlock";
import TaskTemplateBlockDetailsBlock from "./TaskTemplateBlockDetailsBlock/TaskTemplateBlockDetailsBlock"; 

interface IProps {
    taskTemplate: TaskTemplate;
}

const TaskTemplateBlockCard: React.FunctionComponent<IProps> = (props: IProps) => (
    <RouterLink to={`/tasktemplates/${props.taskTemplate.id}`} type={RouterLinkType.default}>
        <Card>
            <CardImage src={props.taskTemplate.videoThumbnailUrl || props.taskTemplate.pictureUrl} />
            <CardContent>
                <TaskTemplateBlockDetailsBlock taskTemplate={props.taskTemplate} />
                {props.taskTemplate.taskRecurrencies.length > 0 ? (<TaskRecurrencyBlock taskRecurency={props.taskTemplate.taskRecurrencies[0]} />) : null}
            </CardContent>
        </Card>
    </RouterLink>
);

export default TaskTemplateBlockCard;


// WEBPACK FOOTER //
// ./src/Components/Pages/TaskTemplateBlockOverview/TaskTemplateBlockView/TaskTemplateBlockCard/TaskTemplateBlockCard.tsx